@let hasPatron = patronSelectors.hasPatron | select: false;
@let available = availabilitySelectors.availableAtPatronsBranchFor(availability) | select:false;
@let availableAtOtherBranches = availabilitySelectors.availableAtOtherBranchesFor(availability) | select:0;

<div class="flex flex-col gap-3" [ngClass]="{'items-center': forTableColumn}">
  <div class="flex flex-col" [ngClass]="{'items-center': forTableColumn}">
    <div class="flex flex-row" [ngClass]="forTableColumn ? 'items-start' : 'items-center'">
      <div class="flex shrink-0">
        @if (hasPatron) {
          <ng-container *ngTemplateOutlet="availabilityIcon; context: {availableCount: available}"/>
        }
      </div>
      <div class="flex flex-col">
        @if (hasPatron) {
          <div class="flex" [ngClass]="forTableColumn ? 'flex-col text-title-medium md:text-title-large' : 'flex-row text-title-medium'">
            <p>{{ available ? 'Available at' : 'Unavailable at' }}</p>
            @if (!forTableColumn) {
              <p>&nbsp;{{ authBranchSelectors.name | select }}</p>
            }
          </div>
        }
        @if (!forTableColumn) {
          <div class="flex flex-row items-center">
            @if (!hasPatron) {
              <ng-container *ngTemplateOutlet="availabilityIcon; context: {availableCount: availableAtOtherBranches}"/>
            }
            <ng-container *ngTemplateOutlet="otherLocationInfo"/>
          </div>
        }
      </div>
    </div>
    @if (forTableColumn) {
      <p class="text-title-medium">{{ authBranchSelectors.name | select }}</p>
    }
  </div>

  @if (forTableColumn) {
    <ng-container *ngTemplateOutlet="otherLocationInfo"/>
  }
</div>

<ng-template #otherLocationInfo>
  <div>
    <span class="text-title-medium" [class.text-success]="availableAtOtherBranches > 0">{{ availableAtOtherBranches }} Available</span>
    <span class="text-body-large"> {{ hasPatron ? 'at other locations' : 'at all locations' }}</span>
  </div>
</ng-template>

<ng-template #availabilityIcon let-availableCount="availableCount">
  <mat-icon class="mr-2" [ngClass]="[forTableColumn ? 'mat-icon-size-5' : 'mat-icon-size-10', availableCount ? 'text-success' :
              'text-error']">
    {{ availableCount ? 'check_circle' : 'cancel' }}
  </mat-icon>
</ng-template>